import moment from 'moment'
import PropTypes from 'prop-types'
import { useContext, useEffect, useState } from 'react'
import { AuthenticationContext } from '../../../context/authenticationContext'
import Trade from '../../Messages/Trade'
import Tooltip from '../../Utilities/Tooltip'

const defaultValues = {
  type: 'open',
  headline: '',
  option: '',
  body: '',
  images: [],
  foundBySAM: false
}

const PostTradeFormPreview = ({ trade }) => {
  const { user } = useContext(AuthenticationContext)
  const [message, setMessage] = useState({
    _id: 'preview-id',
    type: trade.type || defaultValues.type,
    headline: trade.headline || defaultValues.headline,
    body: trade.body || defaultValues.body,
    extra: [
      {
        key: 'option',
        type: 'plain-text',
        value: trade.option || defaultValues.option
      },
      {
        key: 'images',
        type: 'images',
        value: trade.images || defaultValues.images
      },
      {
        key: 'foundBySAM',
        type: 'boolean',
        value: trade.foundBySAM || defaultValues.foundBySAM
      }
    ],
    user,
    edited: false,
    createdAt: moment().format('YYYY-MM-DDTHH:mm:ss')
  })

  useEffect(() => {
    setMessage((message) => ({
      ...message,
      ...{ type: trade.type || defaultValues.type },
      ...{ headline: trade.headline || defaultValues.headline },
      ...{ body: trade.body || defaultValues.body },
      extra: [
        {
          key: 'option',
          type: 'plain-text',
          value: trade.option || defaultValues.option
        },
        {
          key: 'images',
          type: 'images',
          value: trade.images || defaultValues.images
        },
        {
          key: 'foundBySAM',
          type: 'boolean',
          value: trade.foundBySAM || defaultValues.foundBySAM
        }
      ]
    }))
  }, [trade])

  return (
    <div className="flex flex-col gap-5">
      <div className="flex items-center">
        <h2 className="mr-3">Trade Preview</h2>
        <Tooltip>Preivew how the trade will appear to users.</Tooltip>
      </div>
      <Trade message={message} truncate />
    </div>
  )
}

PostTradeFormPreview.propTypes = {
  trade: PropTypes.object
}

export default PostTradeFormPreview
